import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Undefined = props => {
  var {
    Undefined: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Undefined');
  return null;
};
Undefined.displayName = 'JVR.Undefined';